export const formatData = response => {
  return response && response.items ? response.items : [];
};

export const getListIdAndListObjById = (data = [], key = null) => {
  if (key === null) {
    return data.reduce(
      (result, item) => {
        return {
          id: result.id + 1,
          listId: result.listId.concat(result.id),
          listObjById: {
            ...result.listObjById,
            [result.id]: item,
          },
        };
      },
      { listId: [], listObjById: {}, id: 0 },
    );
  }
  return data.reduce(
    (result, item) => {
      if (!item[key]) {
        return result;
      }

      return {
        listId: result.listId.concat(item[key]),
        listObjById: {
          ...result.listObjById,
          [item[key]]: item,
          [item[key].toUpperCase()]: item,
        },
      };
    },
    { listId: [], listObjById: {} },
  );
};
